import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ['copyPreviousItem'];
  static values = { typeId: String, url: String };

  add(event) {
    event.preventDefault();
    
    const copyPrevious = this.hasCopyPreviousItemTarget ? this.copyPreviousItemTarget.checked : false;
    const typeId = this.typeIdValue;
    
    const subItemsData = this.collectSubItemsData();
    
    // Show loading state
    const button = event.currentTarget;
    const originalText = button.innerHTML;
    button.innerHTML = '<span class="spinner-border spinner-border-sm mr-1" role="status"></span>Adding...';
    button.disabled = true;
    
    const currentTabindex = this.getCurrentTabindex();
    
    // Make Ajax request
    const formData = new FormData();
    formData.append('type_id', typeId);
    formData.append('copy_previous', copyPrevious);
    formData.append('current_tabindex', currentTabindex);
    
    Object.keys(subItemsData).forEach(fieldName => {
      const value = subItemsData[fieldName];
      if (Array.isArray(value)) {
        value.forEach(v => formData.append(fieldName, v));
      } else {
        formData.append(fieldName, value);
      }
    });
    
    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: formData
    }).then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    }).then(html => {
      eval(html);
    }).catch(error => {
      console.error('Error adding sub-item:', error);
      alert('Error adding sub-item. Please try again.');
    }).finally(() => {
      // Restore button state
      button.innerHTML = originalText;
      button.disabled = false;
    });
  }

  collectSubItemsData() {
    const subItemsData = {};
    
    // Find all sub-item containers within the sub-items section
    const subItemContainers = document.querySelectorAll('#sub-items-container .nestedfield-item');
    
    subItemContainers.forEach((container, index) => {
      // Collect all form inputs from this sub-item
      const inputs = container.querySelectorAll('input, select, textarea');
      console.log(`Sub-item ${index} has ${inputs.length} inputs`);
      
      inputs.forEach(input => {
        if (input.name && input.name.includes('[sub_items_attributes]')) {
          if (subItemsData[input.name] === undefined) {
            subItemsData[input.name] = [];
          }
          
          if (input.type === 'checkbox') {
            if (input.checked) {
              subItemsData[input.name].push(input.value || 'true');
            }
          } else if (input.type === 'radio') {
            if (input.checked) {
              subItemsData[input.name] = [input.value];
            }
          } else {
            if (input.value) {
              subItemsData[input.name].push(input.value);
            }
          }
        }
      });
    });
    
    // Convert single-value arrays back to single values for non-array fields
    Object.keys(subItemsData).forEach(key => {
      if (Array.isArray(subItemsData[key]) && subItemsData[key].length === 1) {
        // Check if this is an array field (ends with [])
        if (!key.endsWith('[]')) {
          subItemsData[key] = subItemsData[key][0];
        }
      }
    });
    
    return subItemsData;
  }


  getCurrentTabindex() {
    const allElements = document.querySelectorAll('[tabindex]');
    let maxTabindex = 0;
    
    allElements.forEach(element => {
      const tabindex = parseInt(element.getAttribute('tabindex'), 10);
      if (!isNaN(tabindex) && tabindex > maxTabindex) {
        maxTabindex = tabindex;
      }
    });
    
    return maxTabindex;
  }
}
